import { Injectable } from '@angular/core';
import { User } from './shared/user/user.model';

@Injectable()
export class Globals {
	role: string = 'test';
	user: User;
	roles:any = [
		{ id:"root", value:"Super Administrador", auth: ['root']},
		{ id:"admin", value:"Administrador", auth: ['root', 'admin']},
		{ id:"manager", value:"Jefe de ventas", auth: ['root', 'admin']},
		{ id:"account", value:"Ejecutivo de cuentas", auth: ['root', 'admin']},
		{ id:"sales", value:"Ventas", auth: ['root', 'admin', 'manager', 'account']}
	];
	
	public setRole(role) {
		this.role = role;
	}
}


// WEBPACK FOOTER //
// ./src/app/global.ts